import { Outlet } from "react-router-dom";
import Wrapper from "src/components/layout/Wrapper";
import Footer from "src/components/layout/nav/Footer";
import LogoNav from "src/components/layout/nav/LogoNav";
import Nav from "src/components/layout/nav/Nav";
import { ExpireHashProvider } from "../context/ExpireHashContext";

function RootLayout() {
  const location = window.location.href.includes("interne-objave");

  return (
    <ExpireHashProvider>
      <div className="flex flex-col min-h-screen">
        <header className="flex-0">{!location ? <Nav /> : <LogoNav />}</header>

        <main className="flex-1">
          <Wrapper>
            <Outlet />
          </Wrapper>
        </main>

        <footer className="flex-0">
          <Footer />
        </footer>
      </div>
    </ExpireHashProvider>
  );
}

export default RootLayout;
